import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../stateHelpers';

const reducers = handleActions({
  [types.CONNECT_SOCKET_TO_SERVER]: mergeIn(() => ({ connectSocket: true })),
}, null);

export default reducers;
